import { MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const Image = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});
